<template>
  <div class="md-layout-item">
    <md-card>
      <md-card-content>
        <div class="md-layout flex-content-left">
          <div class="md-layout-item md-size-15">
            <md-table>
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="perPage" name="pages">
                    <md-option
                      v-for="item in perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </md-table>
          </div>
        </div>
        <md-table
          :value="tableData"
          class="paginated-table table-striped table-hover mt-25"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="اسم النسخة الاحتياطية">
              {{ item.databaseName }}
            </md-table-cell>

            <md-table-cell md-label="تاريخ النسخة">
              <span dir="ltr">
                {{ formatDate(item.createdAt) }}
              </span>
            </md-table-cell>

            <md-table-cell md-label="حجم النسخة">
              {{ item.size }}
            </md-table-cell>

            <md-table-cell md-label>
              <div class="md-just-icon md-info md-simple"></div>
              <md-button
                class="md-just-icon md-primary md-simple"
                @click="downloadBackup(item)"
              >
                <md-icon>cloud_download</md-icon>
              </md-button>

              <md-button
                class="md-just-icon md-success md-simple"
                @click="handleRestore(item)"
              >
                <md-icon>restore</md-icon>
              </md-button>

              <md-button
                class="md-just-icon md-danger md-simple"
                @click.native="handleDelete(item)"
              >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <div class></div>
        <pagination
          class="pagination-no-border pagination-success"
          v-model="currentPage"
          :per-page="perPage"
          :total="total"
        ></pagination>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { Pagination } from "@/components";
export default {
  name: "the-table",
  components: {
    Pagination,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    isRestoring: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 15, 20],
    };
  },

  computed: {
    total() {
      return this.tableData.length;
    },
    from() {
      return (this.currentPage - 1) * this.perPage;
    },
    to() {
      return Math.min(this.from + this.perPage, this.total);
    },
  },
  methods: {
    downloadBackup(backup) {
      window.open(backup.path, "_blank");
    },
    handleRestore(item) {
      this.$emit("handleRestore", item);
    },
    handleDelete(item) {
      this.$emit("handleDelete", item);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-25 {
  margin-top: 25px;
}

.flex-content-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.footer-table {
  margin-top: 15px;
}

.md-table {
  .md-table-head {
    padding: 12px 8px;
  }
}

.md-just-icon {
  width: 34px;
  height: 34px;
  padding: 0;
  margin: 0 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
